<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../assets/images/return.png" @click="$router.go(-1)"><span>物业员工</span>
    </div>
    <div class="orderlist-wrapper">
        <div class="order-row mar_bot">
            <div class="layout mar_bot top">
                <div class="flex-1">用户信息</div>
            </div>
            <div class="user-info">
                <img style="height: 70px" class="user-img" v-if="info.head_portrait" :src="info.head_portrait">
                <img style="height: 70px" class="user-img" v-else src="../../assets/images/default-head.png">
                <div class="center user-detail">
                    <div class="layout mar_bot">
                        <div class="flex-1"><label>姓名</label>{{info.nickname}}</div>
                    </div>
                    <div class="layout mar_bot">
                        <div class="flex-1"><label>电话</label>{{info.user_tel}}</div>
                    </div>
                    <div class="layout mar_bot">
                      <div class="flex-1">
                        <div style="display: inline-block; position: relative;"><label>住址</label></div>
                        <div style="display: inline-block; position: absolute;">{{info.room_data}}</div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-row mar_bot">
            <div class="layout mar_bot top">
                <div class="flex-1">扫码结果</div>
            </div>
            <div class="center">
                <div class="layout mar_bot">
                    <div class="flex-1" v-if="get_data.start_time_info"><label class="flex-2">出行有效周期</label>{{get_data.start_time_info}} - {{get_data.end_time_info}}</div>
                </div>
                <!-- 可出 -->
                <div v-if="get_data.can_out == 1" class="flex-3 fount-green">周期内尚未出行</div>
                <!-- 不可出 -->
                <div v-else class="flex-3 fount-red">{{get_data.cnt_out_reason}}</div>
                <div v-if="get_data.travel_time_info" class="flex-4" style="font-weight: normal">记录： {{get_data.travel_time_info}}</div>
                <div class="backdrop-bottom">
                  <button class="entry-btn" @click="codeVerify(2)">进入</button>
                  <!-- 不可出时按钮灰色 -->
                  <button v-if="get_data.can_out === 1" class="out-btn-1" @click="codeVerify(1)">出行</button>
                  <button v-else class="out-btn-2">出行</button>
                </div>
                <div class="backdrop-bottom return-btn">
                  <button @click="returnBtn">返回</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'MyApproval',
  metaInfo: {
    title: '出行管控'
  },
  data () {
    return {
      info: {},
      get_data: {},
      room_id: 0,
      user_id: 0,
      message: '',
      loading: false // 加载动画
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.info = this.$route.query.info
    console.log('核销页数据-----------')
    console.log(this.$route.query)
    this.room_id = this.info.room_id
    this.user_id = this.info.user_id
    this.getCodeInfo()
  },
  methods: {
    // 获取出行信息
    getCodeInfo () {
      // 获取信息
      this.axios.post('/wechat/user_travel/travelCheck', {
        village_id: this.villageId,
        member_id: this.memberId,
        room_id: this.room_id,
        user_id: this.user_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.get_data = res.data.data
          console.log('显示数据-----------')
          console.log(this.get_data)
        } else {
          this.$toast({
            message: res.data.data.message,
            duration: 5000
          })
          this.returnBtn()
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 出行码核销
    codeVerify (status) {
      var travelTypeName = ''
      if (status === 1) {
        travelTypeName = '出行'
      } else {
        travelTypeName = '进入'
      }
      // 核销
      this.axios.post('/wechat/user_travel/travelSubmit', {
        village_id: this.villageId,
        member_id: this.memberId,
        room_id: this.info.room_id,
        user_id: this.info.user_id,
        user_tel: this.info.user_tel,
        nickname: this.info.nickname,
        head_portrait: this.info.head_portrait,
        travel_type: status
      }).then((res) => {
        // 核销结果
        if (res.data.status === 1) {
          this.message = travelTypeName + '成功'
        } else {
          this.message = travelTypeName + '失败，' + res.data.message
        }
        this.$messagebox({
          message: this.message,
          confirmButtonText: '确定'
        }).then(action => {
          if (action === 'confirm') { // 确认的回调
            this.returnBtn()
          }
        })
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    returnBtn () {
      this.$router.push({name: 'Index'})
    },
    // 点击空白地方关闭
    clickBlank () {
      this.approvalTypePopup = false
    }
  }
}
</script>
<style scoped>
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  padding: 0px 15px 20px;
  text-align: center;
  margin:0 auto;
}
.backdrop-bottom button {
  height: 40px;
  line-height: 39px;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #7c7b80;
  color: #7c7b80;
  font-size: 16px;
  padding: 0 30px;
  margin-top: 30px;
  box-shadow: 2px 2px 5px #888888;
}
.backdrop-bottom .out-btn-1 {
  background-color: #ff7c12;
  border: 1px solid #ff7c12;
  color: #ffffff;
  margin-left: 30px;
}
.backdrop-bottom .out-btn-2 {
  background-color: #b9b9b9;
  border: 1px solid #b9b9b9;
  color: #ffffff;
  margin-left: 30px;
}
.backdrop-bottom .entry-btn {
  background-color: #35c53b;
  border: 1px solid #35c53b;
  color: #ffffff;
  margin-right: 30px;
}
.return-btn{
  margin-top: 30px;
  padding-bottom: 50px;
}
.flex-4{
  margin-top: -50px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 80px;
}
.flex-3{
    height: 170px;
    line-height: 50px;
    text-align: center;
    font-weight: 1000;
    font-size: 23px;
    width: 200px;
    margin: 0 auto;
    padding-top: 50px;
    margin-bottom: 30px;
}
.fail-info{
  padding-top: 5px;
  font-weight: normal;
  font-size: 14px;
}
.fount-red{
  color: red;
}
.fount-green{
  color: green;
}
.user-info{
  position: relative;
  padding-bottom: 20px;
}
.user-img{
    display: inline-block;
    margin-left: 10px;
    position: absolute;
}
.user-detail{
    display: inline-block;
    margin-left: 100px;
    margin-top: 5px;
}
.orderlist-wrapper {
  color: #313131;
  font-size: 13px;
}
.orderlist-wrapper .order-row {
  background-color: #ffffff;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.orderlist-wrapper .layout .more {
  padding: 0;
}
.orderlist-wrapper .layout .more img {
  width: 20px;
  height: 20px;
}
.orderlist-wrapper .order-row .top {
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
  font-size: 15px;
}
.orderlist-wrapper .order-row .top .flex-1 {
  font-weight: bold;
}
.orderlist-wrapper .order-row .center {
  padding: 0 10px;
}
.orderlist-wrapper .order-row .center label {
  color: #999;
  display: inline-block;
  width: 64px;
}
.orderlist-wrapper .order-row .bottom {
  padding: 10px;
}
.orderlist-wrapper .order-row .bottom .flex-1 {
  text-align: center;
}
.orderlist-wrapper .order-row .bottom label {
  color: #999;
}
.orderlist-wrapper .order-row .bottom label img {
  width: 9px;
  height: 9px;
  padding-left: 3px;
}
.orderlist-wrapper .order-row .bottom .num {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}
.mar_bot {
  margin-bottom: 8px;
}
.orderlist-wrapper .more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
.flex-2{
    width: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TravelControl/CodeMessage.vue